import {Injectable} from '@angular/core';
import {GlobalDataService} from "./global-data.service";
import {ModuleData, ModuleStatus} from "../models";
import {UserService} from "./user.service";

@Injectable({
    providedIn: 'root'
})
export class ParametersService {
    modules: ModuleData[] = [];
    selectedSettingsModuleId: number = 0;
    selectedModuleType: string = '';
    selectedModuleCompany: string = '';
    selectedModule: ModuleStatus = {
        moduleStatus: false,
        controllerStatus: false
    };
    showLoginBox: boolean = true;
    offline: boolean = false;

    urlCompany: string = '';
    loginBoxLogoClass: string = '';

    selectedModuleIndex: number = 0;
    selectedModuleHash: string | 0 = 0;
    redirecting: boolean = false;

    constructor(
        private user: UserService,
        private globalData: GlobalDataService
    ) {
        this.detectUrlCompany();
    }

    showLoginBoxFunction(): void {
        this.showLoginBox = true;
    }

    demoAccount(): boolean {
        const arrayIndex = this.globalData.demoAccounts.indexOf(this.user.username);
        return arrayIndex >= 0;
    }

    hasModules(): boolean{
        return  Object.keys(this.modules).length > 0
    }

    selectedModuleIsActive(): boolean {
        return (
            this.selectedModule.moduleStatus && this.selectedModule.controllerStatus
        );
    }

    isZonesSystemControllerType(): boolean {
        return this.selectedModuleType === 'zones_system_controller';
    }

    isZonesOrZonesSystemControllerType(): boolean {
        return this.selectedModuleType === 'zones_controller' || this.selectedModuleType === 'zones_system_controller'
    }

    clearModulesData(): void {
        this.modules = [];
        this.selectedModuleType = '';
        this.selectedModuleCompany = '';
        this.selectedModule = {
            moduleStatus: null,
            controllerStatus: null
        };
        this.selectedModuleIndex = 0;
        this.selectedModuleHash = 0;
        window.localStorage.removeItem('selectedModuleHash');
    }

    clearLocalStorage(): void {
        window.localStorage.removeItem('selectedModuleHash');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('pins');
        window.localStorage.removeItem('subtitlesData');
    }

    private detectUrlCompany(): void {
        const url = window.location.href;

        if (url.indexOf('app') > -1) {
            this.urlCompany = 'app';
            this.loginBoxLogoClass = 'login-box__logo--tech';
        } else if (url.indexOf('polypipe') > -1) {
            this.urlCompany = 'polypipe';
            this.loginBoxLogoClass = 'login-box__logo--polypipe';
        } else if (url.indexOf('opop') > -1) {
            this.urlCompany = 'opop';
            this.loginBoxLogoClass = 'login-box__logo--opop';
        } else if (url.indexOf('oeg') > -1) {
            this.urlCompany = 'oeg';
            this.loginBoxLogoClass = 'login-box__logo--oeg';
        } else if (url.indexOf('elias') > -1) {
            this.urlCompany = 'elias';
            this.loginBoxLogoClass = 'login-box__logo--elias';
        } else if (url.indexOf('jawo') > -1) {
            this.urlCompany = 'jawo';
            this.loginBoxLogoClass = 'login-box__logo--jawo';
        } else if (url.indexOf('roth') > -1) {
            this.urlCompany = 'roth';
            this.loginBoxLogoClass = 'login-box__logo--roth';
        } else if (url.indexOf('kolton') > -1) {
            this.urlCompany = 'kolton';
            this.loginBoxLogoClass = 'login-box__logo--kolton';
        } else if (url.indexOf('klimor') > -1) {
            this.urlCompany = 'klimor';
            this.loginBoxLogoClass = 'login-box__logo--tech';
        } else if (url.indexOf('verano') > -1) {
            this.urlCompany = 'verano';
            this.loginBoxLogoClass = 'login-box__logo--verano';
        } else {
            this.urlCompany = 'tech';
            this.loginBoxLogoClass = 'login-box__logo--tech';
        }
    }
}
